export const INVOICE_SUMMARY_SHIMMER_TEST_ID = 'invoice-summary-shimmer';
